// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-feedback {
  background-color: rgba(var(--white));
  padding: 2.5rem;
  display: inline-block;
  border-radius: 0.5rem;
  font-weight: 300;
  position: relative;
  box-sizing: border-box;
  max-width: 25.625rem;
}
.modal-feedback__close {
  position: absolute;
  top: 0;
  right: -2.5rem;
}
@media (max-width: 768px) {
  .modal-feedback__close {
    top: 1.5rem;
    right: 1.5rem;
  }
}
.modal-feedback__line {
  height: 1px;
  width: 100%;
  background-color: rgba(var(--blue-grey-300));
  margin: 2rem 0;
}
@media (max-width: 768px) {
  .modal-feedback__line {
    margin: 2rem 0 !important;
  }
}
.modal-feedback__title {
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.3;
  color: rgba(var(--grey-800));
  text-align: left;
}
.modal-feedback__subtitle {
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.67;
  font-family: var(--merriweather);
  color: rgba(var(--grey-600));
  text-align: left;
  white-space: pre-line;
  margin-top: 0.5rem;
}
.modal-feedback__product {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  margin: 1.5rem 0;
}
@media (max-width: 768px) {
  .modal-feedback__product {
    margin: 1.5rem 0 !important;
  }
}
.modal-feedback__product-img {
  height: 100px;
  width: 100px;
  border-radius: 0.5rem;
  object-fit: cover;
  display: block;
}
.modal-feedback__product-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 0.5rem;
}
.modal-feedback__product-info-name {
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.57;
  font-family: var(--merriweather);
  color: rgba(var(--grey-800));
}
.modal-feedback__product-info-material {
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.5;
  color: rgba(var(--grey-600));
}
.modal-feedback__fields {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
@media (max-width: 768px) {
  .modal-feedback__logo {
    margin-top: 3rem;
  }
}
.modal-feedback__button {
  margin-top: 2rem;
  height: 3rem !important;
  width: 100%;
}
@media (max-width: 768px) {
  .modal-feedback__button {
    position: fixed;
    bottom: 1.5rem;
    left: 1.5rem;
    right: 1.5rem;
    margin-top: 0 !important;
    width: auto !important;
  }
}
@media (max-width: 1300px) {
  .modal-feedback {
    padding: 2rem;
  }
  .modal-feedback .modal-feedback__fields {
    gap: 1rem;
  }
  .modal-feedback .modal-feedback__button {
    margin-top: 1.5rem;
  }
  .modal-feedback .modal-feedback__line {
    margin: 1.5rem 0;
  }
  .modal-feedback .modal-feedback__product {
    margin: 1rem 0;
  }
}
@media (max-width: 768px) {
  .modal-feedback {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
    padding: 1rem;
  }
}
.modal-feedback-wrapper {
  position: fixed;
  display: table;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  transform: scale(0);
  z-index: 1;
}
@media (max-width: 768px) {
  .modal-feedback-wrapper {
    z-index: 2;
  }
}
.modal-feedback-wrapper__background {
  display: table-cell;
  background-color: rgba(var(--black), 0.8);
  text-align: center;
  vertical-align: middle;
}
.modal-feedback-wrapper_open {
  transform: scale(1);
}
.modal-feedback-wrapper_open .modal-feedback-wrapper__background {
  background-color: rgba(var(--black));
  animation: fadeIn 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.modal-feedback-wrapper_open .modal-feedback-wrapper__background .modal-feedback {
  opacity: 0;
  animation: scaleUp 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.modal-feedback-wrapper_close {
  transform: scale(1);
  animation: quickScaleDown 0s 0.5s linear forwards;
}
.modal-feedback-wrapper_close .modal-feedback-wrapper__background {
  animation: fadeOut 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.modal-feedback-wrapper_close .modal-feedback-wrapper__background .modal-feedback {
  animation: scaleDown 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
@keyframes fadeIn {
  0% {
    background-color: rgba(var(--black), 0);
  }
  100% {
    background-color: rgba(var(--grey-800), 0.5);
  }
}
@keyframes scaleUp {
  0% {
    transform: scale(0.8) translateY(-100vh);
    opacity: 0;
  }
  100% {
    transform: scale(1) translateY(0px);
    opacity: 1;
  }
}
@keyframes quickScaleDown {
  0% {
    transform: scale(1);
  }
  99.9% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes fadeOut {
  0% {
    background-color: rgba(var(--grey-800), 0.5);
  }
  100% {
    background-color: rgba(var(--black), 0);
  }
}
@keyframes scaleDown {
  0% {
    transform: scale(1) translateY(0px);
    opacity: 1;
  }
  100% {
    transform: scale(0.8) translateY(-100vh);
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/ModalFeedback/styles.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;AACF;AACE;EACE,kBAAA;EACA,MAAA;EACA,cAAA;AACJ;AACI;EALF;IAMI,WAAA;IACA,aAAA;EAEJ;AACF;AACE;EACE,WAAA;EACA,WAAA;EACA,4CAAA;EACA,cAAA;AACJ;AACI;EANF;IAOI,yBAAA;EAEJ;AACF;AACE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;AACJ;AAEE;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gCAAA;EACA,4BAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AADJ;AAGI;EANF;IAOI,2BAAA;EAAJ;AACF;AAEI;EACE,aAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AADN;AAGM;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gCAAA;EACA,4BAAA;AADR;AAIM;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;AAFR;AAOE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AALJ;AASI;EADF;IAEI,gBAAA;EANJ;AACF;AASE;EACE,gBAAA;EACA,uBAAA;EACA,WAAA;AAPJ;AASI;EALF;IAMI,eAAA;IACA,cAAA;IACA,YAAA;IACA,aAAA;IACA,wBAAA;IACA,sBAAA;EANJ;AACF;AASE;EAxHF;IAyHI,aAAA;EANF;EAQE;IACE,SAAA;EANJ;EASE;IACE,kBAAA;EAPJ;EAUE;IACE,gBAAA;EARJ;EAWE;IACE,cAAA;EATJ;AACF;AAYE;EA5IF;IA6II,WAAA;IACA,eAAA;IACA,YAAA;IACA,gBAAA;IACA,aAAA;EATF;AACF;AAWE;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;EACA,UAAA;AATJ;AAWI;EAVF;IAWI,UAAA;EARJ;AACF;AAUI;EACE,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,sBAAA;AARN;AAWI;EACE,mBAAA;AATN;AAUM;EACE,oCAAA;EACA,kEAAA;AARR;AAUQ;EACE,UAAA;EACA,mEAAA;AARV;AAaI;EACE,mBAAA;EACA,iDAAA;AAXN;AAaM;EACE,mEAAA;AAXR;AAaQ;EACE,qEAAA;AAXV;AAiBE;EACE;IACE,uCAAA;EAfJ;EAiBE;IACE,4CAAA;EAfJ;AACF;AAiBE;EACE;IACE,wCAAA;IACA,UAAA;EAfJ;EAiBE;IACE,mCAAA;IACA,UAAA;EAfJ;AACF;AAiBE;EACE;IACE,mBAAA;EAfJ;EAiBE;IACE,mBAAA;EAfJ;EAiBE;IACE,mBAAA;EAfJ;AACF;AAiBE;EACE;IACE,4CAAA;EAfJ;EAiBE;IACE,uCAAA;EAfJ;AACF;AAiBE;EACE;IACE,mCAAA;IACA,UAAA;EAfJ;EAiBE;IACE,wCAAA;IACA,UAAA;EAfJ;AACF","sourcesContent":[".modal-feedback {\n  background-color: rgba(var(--white));\n  padding: 2.5rem;\n  display: inline-block;\n  border-radius: 0.5rem;\n  font-weight: 300;\n  position: relative;\n  box-sizing: border-box;\n  max-width: 25.625rem;\n\n  &__close {\n    position: absolute;\n    top: 0;\n    right: -2.5rem;\n\n    @media (max-width: 768px) {\n      top: 1.5rem;\n      right: 1.5rem;\n    }\n  }\n\n  &__line {\n    height: 1px;\n    width: 100%;\n    background-color: rgba(var(--blue-grey-300));\n    margin: 2rem 0;\n\n    @media (max-width: 768px) {\n      margin: 2rem 0 !important;\n    }\n  }\n\n  &__title {\n    font-weight: 500;\n    font-size: 1.5rem;\n    line-height: 1.3;\n    color: rgba(var(--grey-800));\n    text-align: left;\n  }\n\n  &__subtitle {\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.67;\n    font-family: var(--merriweather);\n    color: rgba(var(--grey-600));\n    text-align: left;\n    white-space: pre-line;\n    margin-top: 0.5rem;\n  }\n\n  &__product {\n    display: flex;\n    align-items: flex-start;\n    gap: 1.5rem;\n    margin: 1.5rem 0;\n\n    @media (max-width: 768px) {\n      margin: 1.5rem 0 !important;\n    }\n\n    &-img {\n      height: 100px;\n      width: 100px;\n      border-radius: 0.5rem;\n      object-fit: cover;\n      display: block;\n    }\n\n    &-info {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      text-align: left;\n      gap: 0.5rem;\n\n      &-name {\n        font-weight: 400;\n        font-size: 0.875rem;\n        line-height: 1.57;\n        font-family: var(--merriweather);\n        color: rgba(var(--grey-800));\n      }\n\n      &-material {\n        font-weight: 400;\n        font-size: 0.75rem;\n        line-height: 1.5;\n        color: rgba(var(--grey-600));\n      }\n    }\n  }\n\n  &__fields {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n\n  &__logo {\n    @media (max-width: 768px) {\n      margin-top: 3rem;\n    }\n  }\n\n  &__button {\n    margin-top: 2rem;\n    height: 3rem !important;\n    width: 100%;\n\n    @media (max-width: 768px) {\n      position: fixed;\n      bottom: 1.5rem;\n      left: 1.5rem;\n      right: 1.5rem;\n      margin-top: 0 !important;\n      width: auto !important;\n    }\n  }\n\n  @media (max-width: 1300px) {\n    padding: 2rem;\n\n    .modal-feedback__fields {\n      gap: 1rem;\n    }\n\n    .modal-feedback__button {\n      margin-top: 1.5rem;\n    }\n\n    .modal-feedback__line {\n      margin: 1.5rem 0;\n    }\n\n    .modal-feedback__product {\n      margin: 1rem 0;\n    }\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    border-radius: 0;\n    padding: 1rem;\n  }\n\n  &-wrapper {\n    position: fixed;\n    display: table;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n    transform: scale(0);\n    z-index: 1;\n\n    @media (max-width: 768px) {\n      z-index: 2;\n    }\n\n    &__background {\n      display: table-cell;\n      background-color: rgba(var(--black), 0.8);\n      text-align: center;\n      vertical-align: middle;\n    }\n\n    &_open {\n      transform: scale(1);\n      .modal-feedback-wrapper__background {\n        background-color: rgba(var(--black));\n        animation: fadeIn 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;\n\n        .modal-feedback {\n          opacity: 0;\n          animation: scaleUp 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;\n        }\n      }\n    }\n\n    &_close {\n      transform: scale(1);\n      animation: quickScaleDown 0s 0.5s linear forwards;\n\n      .modal-feedback-wrapper__background {\n        animation: fadeOut 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;\n\n        .modal-feedback {\n          animation: scaleDown 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;\n        }\n      }\n    }\n  }\n\n  @keyframes fadeIn {\n    0% {\n      background-color: rgba(var(--black), 0);\n    }\n    100% {\n      background-color: rgba(var(--grey-800), 0.5);\n    }\n  }\n  @keyframes scaleUp {\n    0% {\n      transform: scale(0.8) translateY(-100vh);\n      opacity: 0;\n    }\n    100% {\n      transform: scale(1) translateY(0px);\n      opacity: 1;\n    }\n  }\n  @keyframes quickScaleDown {\n    0% {\n      transform: scale(1);\n    }\n    99.9% {\n      transform: scale(1);\n    }\n    100% {\n      transform: scale(0);\n    }\n  }\n  @keyframes fadeOut {\n    0% {\n      background-color: rgba(var(--grey-800), 0.5);\n    }\n    100% {\n      background-color: rgba(var(--black), 0);\n    }\n  }\n  @keyframes scaleDown {\n    0% {\n      transform: scale(1) translateY(0px);\n      opacity: 1;\n    }\n    100% {\n      transform: scale(0.8) translateY(-100vh);\n      opacity: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
